module.exports = "https://static.cdns.space/classicbook-temp-tx/img/4-2.71a8bb07.jpg";